import { theme } from "@talkouttech/portal-shared";
import { useAuth, useClient } from "context/auth-context";
import { Tenant, TenantBrandConfig } from "domain/company";
import { useTenant } from "hooks/useTenant";
import { useQuery } from "react-query";

export const useTenantDetails = () => {
  const { isAuthenticated } = useAuth();
  const client = useClient<Tenant>();
  const { activeTenant } = useTenant();

  const { data, isLoading } = useQuery<Tenant, Error>({
    enabled: isAuthenticated,
    queryKey: ["tenant-details", activeTenant],
    queryFn: () => client(`tenants/${activeTenant}`)
  });

  return { data, isLoading };
};

export function useGetTenantBranding() {
  const tenantDetails = useTenantDetails();
  const { identity } = useAuth();
  const { activeTenant } = useTenant();

  const organisationId = identity?.tenantInfo?.[activeTenant]?.organisationId;
  const organisationBrandConfig: TenantBrandConfig | undefined = organisationId
    ? tenantDetails?.data?.organisationBrandConfig?.[organisationId]
    : undefined;
  const brandConfig = organisationBrandConfig ?? tenantDetails?.data?.brandConfig;

  const headerBackgroundColour = brandConfig?.headerBackgroundColour ?? theme.colors.black;
  const headerForegroundColour = brandConfig?.headerForegroundColour ?? "#fff";
  const logoUrl = brandConfig?.logoUrl;

  return {
    headerBackgroundColour,
    headerForegroundColour,
    logoUrl
  };
}
